import React, { useCallback } from "react";
import "./files-drop-zone.component.scoped.scss";
import { useTranslation } from "react-i18next";
import { useDropzone } from "react-dropzone";
import { icons } from "../../statics/icons";
import { showToastMsg } from "../../helpers";

const FilesDropZone = (props: any) => {
  const { t } = useTranslation();

  const onDrop = useCallback((acceptedFiles) => {
    props.onDropFiles(acceptedFiles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onDropRejected = useCallback(
    (fileRejections) => {
      if (fileRejections.length > 0) {
        const rejectedFile = fileRejections[0];
        const fileName = rejectedFile.file.name;
        const message = `${fileName} ${t("IS_NOT_AN_ACCEPTED_FILE_TYPE")}`;
        showToastMsg("error", message);
      }
    },
    [t],
  );

  const { getRootProps, isDragActive } = useDropzone({
    onDrop,
    onDropRejected,
    accept: props.acceptTypes,
  });

  return (
    <div {...getRootProps({ className: "dropzone h-100" })}>
      {isDragActive && !props.isSaving ? (
        <div className="dropzone-overlay">
          <div className="drop-img">
            <img src={icons.DROP_FILE} alt="" />
          </div>
          <h3 className="drop-title">{t("DRAG_AND_DROP_FILE")}</h3>
          <p className="drop-text">{t("RELEASE_THE_FILE_TO_UPLOAD")}</p>
        </div>
      ) : null}
      {props.children}
    </div>
  );
};

export default FilesDropZone;
